import moment from "moment";
import { API_DATE_FORMAT, HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

export const getPatientDocumentDefaultExpirationDate = async (params) => {
  const response = await http.get(
    HTTP_ENDPOINTS.getDefaultDocumentExpirationDate(),
    {
      params: {
        label: params.documentType,
        created_date: params.createdDate,
      },
    },
  );

  const [defaultSettings] = Object.values(response.data?.data || {});
  const defaultDays = defaultSettings?.default_expire_date;
  const days =
    typeof defaultDays === "number" || typeof defaultDays === "string"
      ? Number(defaultDays)
      : NaN;
  const createdDate = moment(params.createdDate || null, moment.ISO_8601, true);
  let expirationDate = null;

  if (Number.isSafeInteger(days) && days > 0 && createdDate.isValid()) {
    const calculatedDate = createdDate.add(days, "days");
    if (calculatedDate.isValid()) {
      expirationDate = calculatedDate.format(API_DATE_FORMAT);
    }
  }

  return {
    ...response,
    data: {
      ...response.data,
      data: expirationDate,
    },
  };
};
